import { SafeHtml } from '@angular/platform-browser';
import { ExQuote } from './../state.model';
import { NavigationService } from './../navigation.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thankyou',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.scss']
})
export class ThankyouComponent implements OnInit {
  thankMessage: SafeHtml;
  constructor(private nav: NavigationService) { }
  ngOnInit() {
    this.thankMessage = this.nav.thankMessage;
    if ( this.nav.attribution.success === true ) {
      this.thankMessage = this.nav.trustHtml(`
      <h2>What happens next?</h2>
      <ul style="width: 80%;
                margin: 20px auto;
                text-align: left;">
        <li>We are matching your needs with the best service providers in your area.</li>
        <li>Our team may contact you for more information on your project if necessary.</li>
        <li>Your project information is sent to our trusted shredding partners who will contact you with a free quote.</li>
      </ul>
      <p><strong>If you have any questions, give us a call at <a href="tel:+18007473365">(800) 747-3365</a>
      or email us at <a href="mailto:help@shrednations.com">help@shrednations.com</a>.</strong></p>
      `);
    }
  }

}
